<template>
  <v-container>
    <v-card class="pa-4" outlined>
      <v-card-title>
        <h3>Temas a tratar</h3>
        <v-spacer></v-spacer>
        <small class="text-caption no-user-select">
          Los compromisos previos se agregan automáticamente a la minuta.
        </small>
      </v-card-title>

      <v-card-text>
        <v-form @submit.prevent="agregarTema">
          <v-text-field 
            persistent-counter
            v-model="tema" 
            label="Añadir un nuevo tema..." 
            outlined 
            dense
            :rules="[temaLengthRule]"
            counter="100"
          ></v-text-field>
          <v-btn 
            color="primary" 
            @click="agregarTema" 
            class="mt-2"
            block
          >
            Agregar +
          </v-btn>
        </v-form>

        <v-divider class="my-4"></v-divider>

        <h4>Lista de temas:</h4>
        <v-list dense>
          <v-list-item v-for="(tema, index) in temas" :key="index">
            <v-row align="center" justify="space-between" class="w-100">
              <v-col>
                <v-list-item-content>
                  <v-list-item-title>{{ index + 1 }}. {{ tema }}</v-list-item-title>
                </v-list-item-content>
              </v-col>
              <v-col class="d-flex justify-end">
                <v-list-item-action>
                  <v-btn icon @click="eliminarTema(index, tema)">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import api from "@/api.js";

export default {
  name: "ProjectPreMeetingView",
  props: {
    meeting: {
      type: Object,
      required: true,
    },
    meetingMinute: {
      type: Object,
      required: true,
    },
  },
  computed: {
    temas() {
      return this.$store.state.meetingMinute?.topics || [];
    },
  },
  data() {
    return {
      tema: "",
      temaLengthRule: (v) => (v?.length <= 100) || "Máximo 100 caracteres permitidos",
    };
  },
  methods: {
    initSocket() {
      this.$socket.emit("event_join", {
        room: this.meeting._id,
        user: JSON.parse(localStorage.getItem("user")),
      });

      this.$socket.on("new_topic", (nuevoTema) => {
        console.log("Nuevo tema recibido:", nuevoTema);
        this.temas.push(nuevoTema.topic);
      });

      this.$socket.on("topic_deleted", (payload) => {
        console.log("Tema eliminado:", payload);
        console.log('temas: ', this.temas);
        this.$store.state.meetingMinute.topics = 
          this.$store.state.meetingMinute.topics.filter((tema) => tema !== payload.topic);
      });
    },
    async agregarTema() {
      if (!this.tema.trim()) {
        console.log("No se agregó el tema porque está vacío");
        return;
      }

      const nuevoTema = this.tema;
      const roomId = this.$route.params.meetingId;

      this.$socket.emit("event_topic", {
        room: roomId,
        user: { name: "Usuario" },
        topic: nuevoTema,
      });

      this.tema = "";

      try {
        console.log("Actualizando la minuta de reunión:", this.meeting._id);
        const response = await api.put(
          `/api/meeting-minute/${this.$store.state.meetingMinute._id}`,
          { topics: [...this.temas, nuevoTema] },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        console.log("Meeting minute updated:", response);
      } catch (e) {
        console.log(e);
      }
    },
    async eliminarTema(index, tema) {
      const roomId = this.$route.params.meetingId;

      this.$socket.emit("event_delete_topic", {
        room: roomId,
        user: { name: "Usuario" },
        topic: tema,
      });

      try {
        console.log("Eliminando tema de la minuta de reunión:", this.meeting._id);
        const response = await api.put(
          `/api/meeting-minute/${this.$store.state.meetingMinute._id}`,
          { topics: this.temas.filter((_, i) => i !== index) },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        console.log("Meeting minute updated:", response);
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    this.initSocket();
    console.log("Premeeting creado - Meeting minute:", this.$store.state.meetingMinute);
  },
};
</script>

<style scoped>
h3, h4 {
  color: #333;
}

.v-list-item {
  border: 1px solid #dfe1e6;
  border-radius: 5px;
  margin-bottom: 8px;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
</style>
